var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBrowserChrome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_browser_chrome") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0.139955046 0.09077442 64.1409596 0.09077442 64.1409596 42.211551 0.139955046 42.211551"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0.0620964273 49.4380761 0.0620964273 49.4380761 57.1787591 0 57.1787591"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1760273,37.3941435 C23.1760273,44.9408842 29.3034117,51.0592426 36.8627961,51.0592426 L36.8627961,51.0592426 C44.4208278,51.0592426 50.5488886,44.9408842 50.5488886,37.3941435 L50.5488886,37.3941435 C50.5488886,29.8475716 44.4208278,23.7297196 36.8627961,23.7297196 L36.8627961,23.7297196 C29.3034117,23.7297196 23.1760273,29.8475716 23.1760273,37.3941435",
    id: "path-5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_browser_chrome",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 0.185930)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.110092, 0.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7781615,0.0972631101 C30.7781615,0.0972631101 52.5840606,-0.874863688 64.1409596,20.8303087 L28.9239183,20.8303087 C28.9239183,20.8303087 22.2730835,20.6136268 16.6032578,28.6059783 C14.9682991,31.9537053 13.2240376,35.409353 15.1863954,42.211551 C12.3514826,37.461023 0.139955046,16.4030386 0.139955046,16.4030386 C0.139955046,16.4030386 8.75416606,0.960796806 30.7781615,0.0972631101",
    id: "Fill-1",
    fill: "#E5322A",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M69.1158982,55.205842 C69.1158982,55.205842 59.0602147,74.3933691 34.3022927,73.4503237 C37.3564899,68.2144888 51.9149716,43.2459759 51.9149716,43.2459759 C51.9149716,43.2459759 55.4298018,37.649901 51.279522,28.7908219 C49.1696734,25.7137372 47.0211275,22.4893962 40.0914349,20.7700614 C45.6645174,20.7154287 70.1810908,20.7735915 70.1810908,20.7735915 C70.1810908,20.7735915 79.3747422,35.8843386 69.1158982,55.205842",
    id: "Fill-4",
    fill: "#FDD900"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0.000000, 16.305775)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.81556697,39.0460116 C4.81556697,39.0460116 -6.93329083,20.8248959 6.2718055,0.0620964273 C9.32328716,5.30011667 23.8739615,30.2731682 23.8739615,30.2731682 C23.8739615,30.2731682 27.0086083,36.085925 36.8309202,36.9561827 C40.5750486,36.6857086 44.4697229,36.4549062 49.4380761,31.3715387 C46.6988881,36.1780442 34.3880716,57.1787591 34.3880716,57.1787591 C34.3880716,57.1787591 16.5790211,57.5071752 4.81556697,39.0460116",
    id: "Fill-6",
    fill: "#65B44C",
    mask: "url(#mask-4)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.3022587,73.6281407 L39.2558459,53.1548108 C39.2558459,53.1548108 44.7024835,52.7337183 49.266722,47.7727282 C46.4335064,52.7090075 34.3022587,73.6281407 34.3022587,73.6281407",
    id: "Fill-9",
    fill: "#60AB48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2974872,37.0884613 C20.2974872,28.0631305 27.6839092,20.7465441 36.7972807,20.7465441 C45.9098037,20.7465441 53.2969046,28.0631305 53.2969046,37.0884613 C53.2969046,46.1144644 45.9098037,53.4308827 36.7972807,53.4308827 C27.6839092,53.4308827 20.2974872,46.1144644 20.2974872,37.0884613",
    id: "Fill-11",
    fill: "#FEFEFE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-6",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1760273,37.3941435 C23.1760273,44.9408842 29.3034117,51.0592426 36.8627961,51.0592426 L36.8627961,51.0592426 C44.4208278,51.0592426 50.5488886,44.9408842 50.5488886,37.3941435 L50.5488886,37.3941435 C50.5488886,29.8475716 44.4208278,23.7297196 36.8627961,23.7297196 L36.8627961,23.7297196 C29.3034117,23.7297196 23.1760273,29.8475716 23.1760273,37.3941435",
    id: "Fill-14",
    fill: "#4B8BF6",
    mask: "url(#mask-6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrowserChrome);
export default __webpack_public_path__ + "static/media/icon_browser_chrome.8522045e0f87a4635ae951ea0b13c7b3.svg";
export { ForwardRef as ReactComponent };